import { requestApi } from './Api';

const getAppointments = async (navigate, params) => {
  return requestApi({ url: '/api/appointment/get_multiple', navigate, params });
};

const getAppointment = async (navigate, params, signal) => {
  if (params?.type !== 'event') {
    return requestApi({ url: '/api/appointment/get_one', navigate, params, signal });
  } else {
    return null;
  }
};

const getAppointmentQueue = async (navigate, params) =>
  requestApi({
    url: '/api/practice/practice_i_queue/appointments/get',
    navigate,
    params
  });

const getAppointmentv2 = async (navigate, params, signal) => {
  if (params?.type !== 'event') {
    return requestApi({ url: '/api/appointment/get_one_v2', navigate, params, signal });
  } else {
    return null;
  }
};

const completeAppointment = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/complete',
    navigate,
    params
  });

const updateAppointmentV2 = async (navigate, params, appointment = {}) => {
  const data = await requestApi({
    url: '/api/appointment/update_v2',
    navigate,
    params
  });

  const updatedAppointment = {
    ...appointment,
    ...data.updatedAppointment
  };

  return { ...data, updatedAppointment };
};

const creationActionAppointment = async (navigate, params, others) =>
  requestApi({
    url: '/api/appointment/action/creation',
    navigate,
    params,
    ...others
  });

const remindAppointment = async (navigate, params, others) =>
  requestApi({ url: '/api/appointment/action/reminder', navigate, params, ...others });

const cancelAppointment = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/cancel',
    navigate,
    params
  });

const acceptAppointment = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/accept',
    navigate,
    params
  });

const remindAppointmentMultiple = async (navigate, params, others) =>
  requestApi({ url: '/api/appointment/action/reminder_multiple', navigate, params, ...others });

const creationActionAppointmentMultiple = async (navigate, params, others) =>
  requestApi({ url: '/api/appointment/action/creation_multiple', navigate, params, ...others });

const cancelMultipleAppointments = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/cancel_multiple',
    navigate,
    params
  });

const getAptTimelineDetails = async (navigate, params) =>
  requestApi({ url: '/api/appointment/timeline/get_details', navigate, params });

const checkPatientArrival = async (navigate, params) =>
  requestApi({ url: '/api/appointment/check_patient_arrival', navigate, params });

const markPatientArrival = async (navigate, params) =>
  requestApi({ url: '/api/appointment/mark_patient_arrival', navigate, params });

const confirmNoShowFee = async (navigate, params) =>
  requestApi({ url: '/api/appointment/confirm_no_show_fee', navigate, params });

const confirmOrDeclineAppointment = async (navigate, params) =>
  requestApi({ url: '/api/appointment/pending_appointment', navigate, params });

const createEntityAppointment = async (navigate, params) =>
  requestApi({ url: '/api/appointment/recurring/create_entity', navigate, params });

const updateAppointmentAndRecurrence = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/recurring/update',
    navigate,
    params
  });
const rescheduleAppointmentRecurrence = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/recurring/reschedule',
    navigate,
    params
  });
const getPatientAppointments = async (navigate, params, type) =>
  requestApi({
    url: `/api/practice/charts/appointments/${type}`,
    navigate,
    params
  });
const getPatientDashboardAppointments = async (navigate, params) =>
  requestApi({ url: '/api/patient/appointment/read', navigate, params });

const getPendingAppointments = async (navigate, params) =>
  requestApi({
    url: '/api/appointment/get_pending',
    navigate,
    params
  });

const getAppointmentWithBalance = async (navigate, params) =>
  requestApi({ url: '/api/patient/checkin/payment/get_balance', navigate, params });

export {
  acceptAppointment,
  cancelAppointment,
  cancelMultipleAppointments,
  checkPatientArrival,
  completeAppointment,
  confirmNoShowFee,
  confirmOrDeclineAppointment,
  createEntityAppointment,
  creationActionAppointment,
  creationActionAppointmentMultiple,
  getAppointment,
  getAppointmentQueue,
  getAppointments,
  getAppointmentv2,
  getAppointmentWithBalance,
  getAptTimelineDetails,
  getPatientAppointments,
  getPatientDashboardAppointments,
  getPendingAppointments,
  markPatientArrival,
  remindAppointment,
  remindAppointmentMultiple,
  rescheduleAppointmentRecurrence,
  updateAppointmentAndRecurrence,
  updateAppointmentV2
};
